import './scripts/main';
import './styles/main';

import './images/homepage-hero-bg.jpg';
import './images/amazon-echo-alexa.jpg';
import './images/homepage-step1.svg';
import './images/homepage-step2.svg';
import './images/homepage-step3.svg';
import './images/arrow-icon.png';
import './images/homepage-play-icon.png';
import './images/homepage-support-icon.svg';
import './images/homepage-verified-icon.svg';
import './images/article-bg.png';
import './images/homepage-hia-logo.png';
import './images/homepage-ikea-logo.png';
import './images/homepage-raywhite-logo.png';
import './images/homepage-realestate-logo.png';
import './images/homepage-mobile-icon.png';
import './images/homepage-mobile-icon-sideways.png';
import './images/homepage-appstore.png';
import './images/homepage-playstore.png';
import './images/homepage-tick.png';
import './images/homepage-top-categories-bg.png';
import './images/carousel-arrow-next.png';
import './images/carousel-arrow-prev.png';




// WEBPACK FOOTER //
// ./homepage/index.js